var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#faf6f1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(28, 20) scale(6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9ecfca",
    d: "M11.983 0C5.374 0 0 5.373 0 11.983c0 2.096.549 4.14 1.595 5.945L.01 23.988          l6.265-1.564a11.947 11.947 0 005.708 1.453c6.61 0 11.983-5.374 11.983-11.983          C23.966 5.374 18.593 0 11.983 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15          -.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463          -2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606          .134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52          -.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01          -.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479          0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487          .709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118          .571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413          -.074-.124-.272-.198-.57-.347z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappBot);
export default __webpack_public_path__ + "static/media/whatsapp-bot.78794be4565819aeb3a736d7ce117799.svg";
export { ForwardRef as ReactComponent };